module.exports = __webpack_public_path__ + "img/2-1.55987d78.png";